import React from "react";
import { Button, Grid, Stack } from "@mui/material";
import Icon from "src/components/icon";
import styled from "styled-components";
import gitlab from "src/assets/icons/gitlab";
import { getGitlabRedirectUrl } from "src/scenes/integrations/utils";
import Link from "src/components/link";
import { Helmet } from "react-helmet";

const H1 = styled.h1`
    font-size: 22px;
    margin: 0;
    font-weight: normal;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const H2 = styled.h2`
    font-size: 14px;
    font-weight: normal;
    margin: 0;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const P = styled.h2`
    font-size: 12px;
    font-weight: normal;
    margin: 0;
    ${({ theme }) => theme.breakpoints.up("sm")} {
        width: 50%;
    }
    color: ${({ theme }) => theme.palette.secondary.main};
`;

const PermissionsIcon = styled(Icon)`
    background-color: #fff;
    border-radius: 16px;
    padding: 24px 12px 24px 12px;
    margin: 32px 0 32px 0;
`;

const handleClick = () => {
    window.location.replace(
        `https://gitlab.com/oauth/authorize?client_id=${
            process.env.GITLAB_CLIENT_ID
        }&redirect_uri=${getGitlabRedirectUrl()}&response_type=code&state=abc123&scope=read_api+read_user+profile`
    );
};

const ContactPlaceholder =
    "In case of any inquiry regarding software permissions, please do not hesitate to ";

const PermissionsGitlab = () => {
    return (
        <>
            <Helmet>
                <title>Adadot - Gitlab Permissions</title>
            </Helmet>
            <Grid container justifyContent="center" mb={4}>
                <Stack
                    direction="column"
                    alignItems="flex-start"
                    style={{ height: "100%", width: "70%" }}
                >
                    <H1>GitLab Integration</H1>
                    <H2>What adadot does with your GitLab data</H2>
                    <PermissionsIcon svg={gitlab} width="100px" height="127" />
                    <P>
                        {ContactPlaceholder}
                        <Link to="/upgrade/inquiry">contact us</Link>
                    </P>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        onClick={handleClick}
                        style={{ width: "102px", marginTop: "32px" }}
                    >
                        Continue
                    </Button>
                </Stack>
            </Grid>
        </>
    );
};

export default PermissionsGitlab;
